<template>
    <div>
        <div class="pagetitle">
            <h1>Gudang</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Gudang</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahGudang" @click="user()">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Gudang 
            </a>
        </div><br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Gudang</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" v-model="searchQuery" @change="fetchGudang" class="form-control mb-3" />
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select id="pageSize" v-model="pageSize" @change="fetchGudang" class="form-select">
                                <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                    {{ size }}
                                </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Nama Lokasi</th>
                                        <th scope="col">Gambar Lokasi</th>
                                        <th scope="col">Link Maps</th>
                                        <th scope="col">Total Pallet Positions</th>
                                        <th scope="col">Total Employees</th>
                                        <th scope="col">Bahasa</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" style="text-align:center">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(Gudang, index) in filteredGudang" :key="Gudang.id">
                                        <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                        <td>{{ Gudang.name }}</td>
                                        <td>
                                            <a :href="apiUrl + Gudang.dc" target="_blank">
                                                <img :src="apiUrl + Gudang.dc" alt="Gudang Image" class="img-thumbnail" style="max-width: 100px; max-height: 100px;">
                                            </a>
                                        </td>
                                        <td>
                                            <a :href="Gudang.link_maps" target="_blank">
                                                <i class="bi bi-geo-alt-fill fa-xs text-primary"></i>
                                            </a>
                                        </td>
                                        <td>{{ Gudang.total_pallet_positions }}</td>
                                        <td>{{ Gudang.total_employees }}</td>
                                        <td>{{ Gudang.language == 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English' }}</td>
                                        <td>
                                            <span v-if="Gudang.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align:center">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', Gudang.id)">
                                                <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteGudang(Gudang.id, Gudang.dc)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', Gudang.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchGudang">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="tambahGudang" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Gudang Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addGudang" nctype="multipart/form-data" :headers="{ 'Content-Type': 'multipart/form-data' }">
                            <input type="hidden" v-model="gudang.created_by">
                            <input type="hidden" v-model="gudang.created_by_name">
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="name" placeholder="Name" v-model="gudang.name">
                                    <label for="name">Name Lokasi</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="gambar" @change="handleFileUpload" accept=".png, .jpg, .jpeg">
                                            <label class="custom-file-label" for="gambar">{{ gambarName }}</label>
                                        </div>
                                    </div>
                                    <div v-if="gambarUrl" class="mt-3 text-center">
                                        <img :src="gambarUrl" alt="Selected Image" class="img-thumbnail" style="max-width: 200px; max-height: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="link_maps" placeholder="Link Maps" v-model="gudang.link_maps">
                                    <label for="link_maps">Link Maps</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="total_pallet_positions" placeholder="Total Pallet" v-model="gudang.total_pallet_positions">
                                    <label for="total_pallet_positions">Total Pallet</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="total_employees" placeholder="Total Employee" v-model="gudang.total_employees">
                                    <label for="total_employees">Total Employee</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="gudang.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="gudang.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailGudangModal" class="modal fade" id="detailGudang" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailGudangModal">Detail Gudang</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="name">Name Lokasi</label>
                                        <input type="text" class="form-control" id="name" v-model="gudang.name" disabled>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="gambar">Gambar</label>
                                        <div class="text-center">
                                            <img :src="apiUrl + gudang.dc" alt="Selected Gudang Image" class="img-thumbnail" style="max-width: 200px; max-height: 200px;">
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="link_maps">Link Maps</label>
                                        <a :href="gudang.link_maps" target="_blank">
                                            <i class="bi bi-geo-alt-fill fa-2x text-primary"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="total_employees">Total Employees</label>
                                        <input type="text" class="form-control" id="total_employees" v-model="gudang.total_employees" disabled>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="total_pallet_positions">Total Pallet Positions</label>
                                        <input type="text" class="form-control" id="total_pallet_positions" v-model="gudang.total_pallet_positions" disabled>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" :value="gudang.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" disabled>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="gudang.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editGudang" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editGudangModalLabel">Edit Gudang</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateGudang">
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="name" placeholder="Name" v-model="gudang.name">
                                    <label for="name">Name Lokasi</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="link_maps" placeholder="Link Maps" v-model="gudang.link_maps">
                                    <label for="link_maps">Link Maps</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="text-center">
                                        <img :src="apiUrl + gudang.dc" alt="Selected Gudang Image" class="img-thumbnail" style="max-width: 200px; max-height: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="number" class="form-control" id="total_pallet_positions" placeholder="Total Pallet" v-model="gudang.total_pallet_positions">
                                    <label for="total_pallet_positions">Total Pallet</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <input type="number" class="form-control" id="total_employees" placeholder="Total Pallet" v-model="gudang.total_employees">
                                    <label for="total_employees">Total Karyawan</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="gudang.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="status" id="status" v-model="gudang.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>    
    </div>
</template>
<script>
import Gudangjs from './jsGudang/gudang';
export default Gudangjs;
</script>